import React, { useState } from 'react';
import images from '../../images';
import CompanyCardModal from '../Modals/CompanyCardModal';
import ProfileBillingTable from './ProfileBillingTable';

const ProfileRight = ({loading, userData }) => {
  const [createdFrom, setCreatedFrom] = useState('');
  const [createdTo, setCreatedTo] = useState('');
  const [filterType, setFilterType] = useState('all');
  const [showCompanyCardModal, setShowCompanyCardModal] = useState(false);
  const limit = 20;

  const openCompanyCardModal = () => {
    setShowCompanyCardModal(true);
  };

  const closeCompanyCardModal = () => {
    setShowCompanyCardModal(false);
  };

  return (
    <div className="profile-right">
      <div className="profile-billing-header">
        <div className="profile-billing-header-top">
          <div className="profile-billing-title">
            <img
                src={images.chatMoney}
                alt=""
                className="profile-billing-icon"
            />
            Денежные операции
          </div>
            <button className="btn btn-primary" onClick={openCompanyCardModal}>Открыть карточку компании</button>
            <div className="profile-billing-date-filters">
              <div className="profile-billing-filter">
                с <input
                  type="date"
                  value={createdFrom}
                  onChange={(e) => setCreatedFrom(e.target.value)}
              />
              </div>
              <div className="profile-billing-filter">
                по <input
                  type="date"
                  value={createdTo}
                  onChange={(e) => setCreatedTo(e.target.value)}
              />
              </div>
            </div>
          </div>
          <div className="profile-billing-header-filters">
            <button
                className={`btn ${filterType === 'all' ? 'btn-primary-filled' : 'btn-primary'}`}
                onClick={() => setFilterType('all')}
            >
              Все
            </button>
            <button
                className={`btn ${filterType === 'leads' ? 'btn-primary-filled' : 'btn-primary'}`}
                onClick={() => setFilterType('leads')}
            >
              Идентификации
            </button>
            <button
                className={`btn ${filterType === 'invoices' ? 'btn-primary-filled' : 'btn-primary'}`}
            onClick={() => setFilterType('invoices')}
          >
            Счета
          </button>
        </div>
      </div>

      <ProfileBillingTable
        loading={loading}
        userData={userData}
        createdFrom={createdFrom}
        createdTo={createdTo}
        filterType={filterType}
      />

      <CompanyCardModal
          isOpen={showCompanyCardModal}
          onClose={closeCompanyCardModal}
      />
    </div>
  );
};

export default ProfileRight;
